export default __webpack_public_path__ + "static/ring-74d70a831519edaa12689440f6697c9f.mp3";